export default "__VITE_ASSET__BewCMDZ1__"